import React, {useMemo} from "react";
import {isMobile, isMobileOnly} from "react-device-detect";
import {Card, CardActions, CardContent, Divider, IconButton} from "@mui/material";
import {
    CalendarMonth as CalendarIcon,
    Directions as MapIcon,
    Email as EmailIcon,
    Link as UrlIcon,
    Phone as CallIcon,
    Sms as SmsIcon
} from "@mui/icons-material";
import {UserAvatar} from "@atttomyx/react-components";
import {nodeUtils} from "../../utils";
import "./nodeCard.css";

const NodeCard = (props) => {
    const { user, node, children } = props;

    const root = useMemo(() => {
        return nodeUtils.isRoot(node, user);
    }, [node, user]);

    return <Card className="node-card" raised={true}>
        <CardContent>
            <UserAvatar user={node} mode="right"/>
            <Divider/>
            <div className="button-row">
                <IconButton
                    color="primary"
                    title="Text"
                    disabled={!isMobile || root || node.phones.length === 0}
                    onClick={() => alert("text")}
                >
                    <SmsIcon/>
                </IconButton>
                <IconButton
                    color="primary"
                    title="Call"
                    disabled={!isMobileOnly || root || node.phones.length === 0}
                    onClick={() => alert("call")}
                >
                    <CallIcon/>
                </IconButton>
                <IconButton
                    color="primary"
                    title="Email"
                    disabled={root || node.emails.length === 0}
                    onClick={() => alert("email")}
                >
                    <EmailIcon/>
                </IconButton>
                <IconButton
                    color="primary"
                    title="Goto URL"
                    disabled={node.urls.length === 0}
                    onClick={() => alert("url")}
                >
                    <UrlIcon/>
                </IconButton>
                <IconButton
                    color="primary"
                    title="Directions"
                    disabled={node.addresses.length === 0}
                    onClick={() => alert("directions")}
                >
                    <MapIcon/>
                </IconButton>
                <IconButton
                    color="primary"
                    title="Goto calendar"
                    disabled={node.dates.length === 0}
                    onClick={() => alert("calendar")}
                >
                    <CalendarIcon/>
                </IconButton>
            </div>
            <Divider/>
        </CardContent>
        <CardActions disableSpacing={true}>
            {children}
        </CardActions>
    </Card>
}

export default NodeCard;
